/** 메뉴 권한 가드 - 권한 밖 화면 주소면 안내를 띄우고 홈으로 보낸다. */
import { useMenuStore, routeBlocked } from '@/stores/menu';
import { useToast } from '@/composables/useToast';
import { MSG } from '@/constants/messages';

export async function menuGuard(to) {
  const menu = useMenuStore();
  await menu.ensureLoaded();
  if (!routeBlocked(menu, to)) return true;
  console.warn(`[menu] 권한 밖 메뉴 접근 차단: ${String(to.name)}`);
  // 주소 직접 입력·알림 링크·즐겨찾기로 들어왔을 때 말없이 홈으로 가면 링크가 깨진 것처럼 보인다
  useToast().warning(MSG.NO_SCREEN_PERMISSION);
  return { name: 'Dashboard' };
}

/** 등록되지 않은 주소(오타 주소, 옛 알림 링크, 지운 화면의 즐겨찾기) - 안내를 띄우고 홈으로 보낸다. */
export function notFoundGuard(to) {
  console.warn(`[router] 없는 주소: ${to?.fullPath}`);
  useToast().warning(MSG.SCREEN_NOT_FOUND);
  return { name: 'Dashboard' };
}
